module.exports = __webpack_public_path__ + "static/media/66-september.8158efc7.jpg";